module.exports = __webpack_public_path__ + "media/images/logos/stem_learning_logo-b0ef7ba89df8b10c24701fefb72c4e4c.svg";